import React from 'react';
import styled from 'styled-components';

interface SwitchProps extends React.InputHTMLAttributes<HTMLInputElement> {
  // checked is a standard prop for input type="checkbox"
}

const SwitchContainer = styled.label`
  position: relative;
  display: inline-block;
  width: ${({ theme }) => theme.spacing(5)}; /* 40px */
  height: ${({ theme }) => theme.spacing(2.5)}; /* 20px */
`;

const SwitchInput = styled.input.attrs({ type: 'checkbox' })`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + span {
    background-color: ${({ theme }) => theme.colors.primary.main};
  }

  &:focus + span {
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.primary.light}30;
  }

  &:checked + span:before {
    transform: translateX(${({ theme }) => theme.spacing(2.5)}); /* 20px */
  }

  &:disabled + span {
    background-color: ${({ theme }) => theme.colors.background.secondary};
    cursor: not-allowed;
  }

  &:disabled:checked + span {
    background-color: ${({ theme }) => theme.colors.primary.dark};
    opacity: 0.6;
  }
`;

const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${({ theme }) => theme.colors.gray[700]};
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  border-radius: ${({ theme }) => theme.shape.borderRadius.xlarge};

  &:before {
    position: absolute;
    content: "";
    height: ${({ theme }) => theme.spacing(2)}; /* 16px */
    width: ${({ theme }) => theme.spacing(2)}; /* 16px */
    left: 2px;
    bottom: 2px;
    background-color: white;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    border-radius: 50%;
  }
`;

export const Switch: React.FC<SwitchProps> = (props) => {
  return (
    <SwitchContainer>
      <SwitchInput {...props} />
      <Slider />
    </SwitchContainer>
  );
};

export default Switch; 